import {
  VscChromeRestore,
  VscChromeClose,
  VscChromeMinimize,
} from "react-icons/vsc";
import filterIcon from "./assets/filter.svg";

export default function BrowserTab() {
  return (
    <div className="chrome-window">
      <div className="title-bar">
        <div className="title-left">
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google Favicon"
          />
          <span>Sign in to continue</span>
        </div>
        <div className="title-right">
          <VscChromeMinimize />

          <VscChromeRestore />

          <VscChromeClose />
        </div>
      </div>
      <div className="url-bar">
        <div className="lock-icon">
          <img src={filterIcon} alt="filter" />
        </div>
        <div className="url">
          https://accounts.google.com/v3/signin/identifier?app_domain=https%3A%2F%2GClAQMkUdpm%...
        </div>
      </div>
    </div>
  );
}
